export const buildRolePolicyRowKey = (roleManagementMode, row, selectedPermissionOrganisationId) => {
  const scopeId = roleManagementMode === 'system'
    ? 'system'
    : (row.organisationId || selectedPermissionOrganisationId || 'system');
  return `${roleManagementMode}:${scopeId}:${row.role}`;
};
